import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Grid, Box, Typography, Button } from '@material-ui/core';
import { Person } from '@material-ui/icons';

import useCurrentUserDb from '../hooks/useCurrentUserDb';
import Redirector from './Redirector';

const DoneSignupSceneWrapper = styled.div`
  height: 100vh;
  width: 100vw;
`;
const ContainerGrid = styled(Grid)`
  height: inherit;
  width: inherit;
`;
const CustomPersonIcon = styled(Person)`
  color: grey;
  margin-right: 8px;
`
const UserName = styled(Box)`
  font-size: 18px;
  text-align: center;
  margin-right: 10px;
`

const getName = (value?: string) => {
  if (!value) return '';
  else if (value.length >=7) return value.substring(0,5) + '...';
  else return value;
}

type DoneSignupSceneProps = {
  redirected: boolean;
  setRedirected: (value: boolean) => void;
}
const DoneSignupScene: React.FC<DoneSignupSceneProps> = ({ redirected, setRedirected }) => {
  const [, currentUser] = useCurrentUserDb();
  const [name, setName] = useState(() => getName(currentUser?.name));

  useEffect(() => {
    if (!currentUser) return;
    setName(getName(currentUser.name));
  }, [currentUser])

  if (!redirected) return <Redirector doneRedirect={() => setRedirected(true)} />;
  return (
    <DoneSignupSceneWrapper>
      <ContainerGrid container justifyContent="center" alignItems="center" direction="column" spacing={6}>
        <Grid item>
          <Typography variant="h5">ユーザ登録が完了しました！</Typography>
        </Grid>
        <Grid item>
          <ContainerGrid container justifyContent="center" alignItems="center" direction="row">
            <CustomPersonIcon />
            <UserName>{ name }</UserName>
          </ContainerGrid>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={() => setRedirected(false)}>続きからはじめる</Button>
        </Grid>
      </ContainerGrid>
    </DoneSignupSceneWrapper>
  );
}

export default DoneSignupScene;
